// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--vWgWQ","align-right":"a10a3f92e9--align-right--QoEer","text":"a10a3f92e9--text--Q7D3p"};